/**
 * Return & Cancellation Policy - shared catalog/product type logic
 */
export default {
    methods: {
        flattenCatalogTree(nodes) {
            if (!nodes || !Array.isArray(nodes)) return [];
            return nodes.reduce((acc, node) => {
                if (node.isProductType) {
                    acc.push({
                        _id: node._id,
                        name:
                            node.name ||
                            node.catalogDescription?.displayName ||
                            node.title ||
                            "",
                    });
                }
                if (node.children?.length) {
                    acc = acc.concat(this.flattenCatalogTree(node.children));
                }
                return acc;
            }, []);
        },
        async fetchProductTypeList() {
            let list = [];
            try {
                if (this.$userRole === "Tenant") {
                    await this.$store.dispatch("catalog/fetchTenantCatalogTree");
                    const tree = this.$store.getters["catalog/GetTenantCatalogTree"];
                    list = this.flattenCatalogTree(tree);
                } else if (this.$userRole === "Partner") {
                    await this.$store.dispatch("catalog/fetchPartnerCatalogTree");
                    const tree = this.$store.getters["catalog/GetPartnerCatalogTree"];
                    list = this.flattenCatalogTree(tree);
                }
                if (list.length === 0) {
                    const res = await this.$store.dispatch(
                        "catalog/fetchCatalogDataByParam",
                        "isProductType",
                    );
                    const response = res?.data?.response;
                    if (Array.isArray(response)) {
                        list = response
                            .filter((x) => x.isProductType === true)
                            .map((x) => ({
                                _id: x._id,
                                name:
                                    x.name ||
                                    x.catalogDescription?.displayName ||
                                    "",
                            }));
                    }
                }
                if (
                    list.length === 0 &&
                    this.$currentUserData?.catalogInfo?.[0]?._id
                ) {
                    const provider = this.$currentUserData.catalogInfo[0]._id;
                    const res = await this.$store.dispatch(
                        "catalog/findCatalogByProviderId",
                        { provider, allFields: true },
                    );
                    const items = Array.isArray(res) ? res : res?.response || [];
                    list = items
                        .filter((x) => x.isProductType === true)
                        .map((x) => ({
                            _id: x._id,
                            name:
                                x.name ||
                                x.catalogDescription?.displayName ||
                                "",
                        }));
                }
            } catch (err) {
                console.error("Failed to load product types:", err);
            }
            return list;
        },
    },
};
